require('./jquery.flot');  
require('./jquery.flot.pie');
require('./jquery.flot.resize');
require('./jquery.flot.animator');
